import { Text } from "./Text";
import type { ComponentPropsWithoutRef, RefObject } from "react";

type NumberInputProps = {
	label?: string;
	value: string;
	onChange: (value: string) => void;
	unit?: string;
	error?: string;
	bare?: boolean;
	className?: string;
	inputClassName?: string;
	inputRef?: RefObject<HTMLInputElement | null>;
	type?: ComponentPropsWithoutRef<"input">["type"];
	inputMode?: ComponentPropsWithoutRef<"input">["inputMode"];
	onKeyDown?: ComponentPropsWithoutRef<"input">["onKeyDown"];
	onBlur?: ComponentPropsWithoutRef<"input">["onBlur"];
	ariaLabel?: string;
	placeholder?: string;
	disabled?: boolean;
	min?: number;
	max?: number;
};

/** Точное числовое поле, допускающее пустой черновик до валидации формы. */
export const NumberInput = ({
	label,
	value,
	onChange,
	unit,
	error,
	bare = false,
	className = "",
	inputClassName = "",
	inputRef,
	type = "number",
	inputMode = "numeric",
	onKeyDown,
	onBlur,
	ariaLabel,
	placeholder,
	disabled = false,
	min,
	max,
}: NumberInputProps) => {
	const input = (
		<input
			ref={inputRef}
			type={type}
			value={value}
			inputMode={inputMode}
			aria-label={ariaLabel}
			placeholder={placeholder}
			disabled={disabled}
			min={min}
			max={max}
			onChange={(event) => onChange(event.target.value)}
			onKeyDown={onKeyDown}
			onBlur={onBlur}
			className={
				bare
					? inputClassName
					: `min-w-0 flex-1 border-0 bg-transparent text-sm font-semibold text-ink outline-none ${inputClassName}`
			}
		/>
	);

	if (bare) return input;

	return (
		<label className="flex min-w-0 flex-col gap-1.5">
			{label && <Text className="text-xs font-medium text-muted">{label}</Text>}
			<div
				className={`flex h-9 min-w-0 items-center rounded-md border border-border bg-surface px-2 focus-within:border-accent ${className}`}
			>
				{input}
				{unit && <Text className="ml-1 text-xs text-muted">{unit}</Text>}
			</div>
			{error && <Text className="text-xs text-danger">{error}</Text>}
		</label>
	);
};
